export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const ENDPOINTS = {
  LOGIN: "onboarding/admin/login",
  SEND_OTP: "onboarding/admin/send-otp",
  VERIFY_OTP: "onboarding/admin/verify-otp",
  CHANGE_PASSWORD: "onboarding/admin/change-password", // NOSONAR
  PROFILE: "onboarding/admin/",
  UPDATE_PROFILE: "onboarding/admin/update",
  LOGOUT: "onboarding/admin/logout",
  UPLOAD_MEDIA: "media",
  CATEGORIES: "categories/admin",
  ADMIN_CATEGORIES: "admin/categories",
  BRANDS: "brands/admin",
  MODELS: "models/admin",
  VEHICLE_TYPES: "vehicleType/admin",
  FUEL_TYPES: "fuelType/admin",
  ENGINE_POWER: "enginePower/admin",
  TRANSMISSION: "transmission/admin",
  DRIVE_TYPE: "driveType/admin",
  EMISSION_CLASS: "emissionClass/admin",
  ENVIRONMENTAL_BADGE: "environmentalBadges/admin",
  DAMAGE_TYPE: "damageType/admin",
  AXLES: "axles/admin",
  FEATURES: "features/admin",
  COLORS: "colors/admin",
  CONDITIONS: "conditions/admin",
  CARS: "cars/admin",
  SPARE_PARTS: "spareParts/admin",
  VARIANTS: "variants/admin",
  MANAGE_USERS: "users/admin",
  EXPORT_USERS: "users/admin/export/csv",
  ACCESSORIES: "accessories/admin",
  CMS: "cms/admin",
  FAQS: "cms/admin/faqs",
  BANNERS: "settings/admin/banners",
  VEHICLE_BANNERS: "settings/admin/vehicles",
  CATEGORY_BANNERS: "settings/admin/categoryBanner",
  DASHBOARD: "dashboard/admin",
  DASHBOARD_GRAPH: "dashboard/admin/analytics",
  STRIPE_PLANS: "stripe/admin/plans/",
  PERMISSIONS: "permissions/admin/",
  SUB_ADMIN: "subadmin/admin",
  REVENUE: "revenue/admin/",
  SHOWROOMS: "showroom/admin/",
  EXPORT_SHOWROOMS: "showroom/admin/export/csv",
  SEND_NOTIFICATION: "notifications/admin/send",
  NOTIFICATIONS: "notifications/admin",
  NOTIFICATIONS_INBOX: "notifications/admin/inbox",
  BLOGS: "blogs/admin/blogs",
  UPLOAD_BLOG_IMAGES: "blogs/admin/blogs/upload-images",
};
